import { useEffect, useMemo } from 'react';
import {
    useGetAccountQuery,
    useGetTransactionsInfiniteQuery,
    useGetPendingTransactionsQuery,
} from 'lib/services';
import { getListItems } from '../../../../../utils/transactions';
import { isEmpty } from 'lib/utils';
import {
    AccountBalanceTransactionItem,
    PendingTransactionItem,
    Transaction,
    TransactionListElement,
} from 'lib/type';
const useTransactions = provider => {

    const {
        data: transactionsData,
        isFetching: isFetchingTransactions,
        refetch: refetchTransactions,
        fetchNextPage,
        hasNextPage
    } = useGetTransactionsInfiniteQuery({ provider });

    const { data: pendingTransactionsData } = useGetPendingTransactionsQuery();

    const { data: account, error } = useGetAccountQuery();

    const transactions: Transaction[] = useMemo(
        () => transactionsData?.pages.flatMap(page => page.items) ?? [],
        [transactionsData],
    );

    const pendingTransactionsCount: number =
        pendingTransactionsData?.totalTransactionsPending;
    const pendingTransactionsAmount: number =
        pendingTransactionsData?.totalAmountPending;

    useEffect(() => {
        refetchTransactions()
    }, [refetchTransactions])

     const loadMoreTransaction = () => {
        fetchNextPage()
    };

    const formattedTransactions = useMemo(
        () => getListItems(transactions),
        [transactions],
    );

    const items = useMemo<TransactionListElement[]>(() => {
        let transactions: TransactionListElement[] = [...formattedTransactions];

        if (pendingTransactionsCount) {
            const pendingItem: PendingTransactionItem = {
                key: 'pending',
                type: 'pending',
                amount: pendingTransactionsAmount,
                count: pendingTransactionsCount,
                value: pendingTransactionsAmount,
            };

            transactions = [pendingItem, ...transactions];
        }

        if (!isEmpty(account)) {
            const accountBalanceItem: AccountBalanceTransactionItem = {
                key: 'accountBalance',
                type: 'accountBalance',
                amount: account?.availableBalance,
            };

            transactions = [accountBalanceItem, ...transactions];
        }

        return transactions;
    }, [
        formattedTransactions,
        pendingTransactionsCount,
        pendingTransactionsAmount,
        account,
    ]);

    return {
        loadMoreTransaction,
        transactions: items,
        isFetchingTransactions,
        hasNextPage,
        error,
    };
};

export default useTransactions;
